import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const adminLogin = (params) => {
  return Api(endPoints.login, params, requestType.POST);
};
export const getSettings = () => {
  return Api(endPoints.settings, null, requestType.GET);
};

export const updateSettings = (id, params) => {
  return Api(`${endPoints.updateSettings}/${id}`, params, requestType.POST);
};
